import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientContractsComponent } from './client-contracts.component';


const routes: Routes = [{
  path: '',
  component: ClientContractsComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientContractsRoutingModule { }
